import {createContext} from "./context-shared";

const context = createContext({
    state: 'error',
    solution: '',
    rate: 0,
    errorMsg: '',
    errorId: 'fallback'
})
export const data = context.view
export const onChanges = context.onChanges

export const waitForSetup = new Promise<void>((resolve) => {
    let errorMsg = '';
    let errorId = 'fallback';
    if (window.__swssConfig && typeof window.__swssConfig === 'object' && 'errorId' in window.__swssConfig) {
        errorId = String(window.__swssConfig.errorId || 'fallback');
        errorMsg = String(window.__swssConfig.errorMsg || '');
    }
    if (!errorId) {
        errorId = 'fallback';
        errorMsg = '';
    }
    context.updateState({
        errorId,
        errorMsg,
    })
    resolve();
})

export function requestValidation() {
    return Promise.resolve();
}
